import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from 'react-router-dom';
import { AuthProvider, CartProvider } from './context';
import { ProtectedRoute, Navigation, HeroBackground } from './components';
import {
  HomePage,
  ArticlePage,
  EventPage,
  AlbumPage,
  AboutPage,
  LinksPage,
  PeoplesPage,
  AlbumsPage,
  AdminDashboardPage,
  EditionPage,
  EditionDetailPage,
  ContactPage,
} from './pages';


const AppRoutes: React.FC = () => {
  const location = useLocation();

  // Determine hero size based on route
  const isHomePage = location.pathname === '/';

  return (
    <div>
      <HeroBackground size={isHomePage ? 'full' : 'third'} />
      <main className='bg-church-lights min-h-screen flex flex-col md:h-screen md:overflow-hidden'>
        <Navigation />
        <div className='flex-1 min-h-0 md:overflow-y-auto'>
        <Routes>
          <Route path='/' element={<HomePage />} />
          <Route path='/news/:id' element={<ArticlePage />} />
          <Route path='/news' element={<Navigate to='/' replace />} />
          <Route path='/events/:id' element={<EventPage />} />
          <Route path='/events' element={<Navigate to='/' replace />} />
          <Route path='/pilgrimages/:id' element={<AlbumPage />} />
          <Route path='/pilgrimages' element={<AlbumsPage />} />
          <Route path='/about' element={<AboutPage />} />
          <Route path='/edition' element={<EditionPage />} />
          <Route path='/edition/:id' element={<EditionDetailPage />} />
          <Route path='/links' element={<LinksPage />} />
          <Route path='/peoples' element={<PeoplesPage />} />
          <Route path='/contact' element={<ContactPage />} />
          <Route
            path='/admin'
            element={
              <ProtectedRoute requireAuth fallback={<Navigate to='/' />}>
                <AdminDashboardPage />
              </ProtectedRoute>
            }
          />
        </Routes>
        </div>
      </main>
    </div>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <AppRoutes />
        </Router>
      </CartProvider>
    </AuthProvider>
  );
};

export default App;
